import { FunctionComponent } from "react";
import ProtocolLayout from "../components/ProtocolLayout";
import { urls } from "../../../../../utils/urls";
import Card from "../../components/Card";
import { NavLink } from "react-router-dom";

interface DigitalBackgroundProps {}

const DigitalBackground: FunctionComponent<DigitalBackgroundProps> = () => {
  const links = [
    {
      name: "Google Meet Background",
      link: urls.google_meet_background,
      //   logo: "/academy/installations.png",
    },
    {
      name: "LinkedIn Banner",
      link: urls.linkedin_banner,
      //   logo: "/academy/cms.png",
    },
  ];
  return (
    <ProtocolLayout>
      <div className="flex flex-col items-center py-12 bg-gray-100 max-h-full ">
        <div className="mb-12 text-3xl font-bold underline">
          Digital Background
        </div>
        <div className="flex flex-col items-center justify-center pt-20 lg:pt-32 max-h-full">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-12 mt-8 w-11/12 lg:w-4/5">
            {links.map(
              (
                el: { name: string; link: string; logo?: string },
                i: number
              ) => {
                return (
                  <NavLink to={el.link}>
                    <div className="flex flex-col rounded-xl bg-white py-8 px-4 h-full">
                      <div className="text-xl h-1/2 mt-4 font-semibold text-center">
                        {el.name}
                      </div>
                    </div>
                  </NavLink>
                );
              }
            )}
          </div>
        </div>
      </div>
    </ProtocolLayout>
  );
};

export default DigitalBackground;
